<!--
활동내역
-->
<template>
    <div class="">

        <!-- 활동내역 리스트 -->
        <div class="component-header uk-flex uk-flex-between uk-flex-bottom">
            <h5 class="uk-margin-remove">
                <span uk-icon="icon: comments"></span>
                댓글

                <!-- 전체활동내역 toggle -->
                <a class="uk-link-reset" v-on:click="showDetail=!showDetail">
                    <span uk-icon="settings" class="uk-text-muted"></span>
                    <span class="uk-text-muted" v-show="showDetail">
                        hide detail
                    </span>
                    <span class="uk-text-muted" v-show="! showDetail">
                        show detail
                    </span>
                </a>

                <!-- 알림톡 버튼 (총괄관리자 통합저장이 아닌 경우만 독립 표시) -->
                <a
                    v-if="qnaId !== null && !hasGeneralAdmin"
                    class="ml-1rem"
                    title="문의글 답변완료 알림톡 발송"
                    @click="$refs['has-done-kakao'].form(qnaId)"
                >
                    <img src="/img/kakao/talk.png" class="w-20" />
                </a>
                <app-qna-has-done-kakao
                    v-if="qnaId !== null && !hasGeneralAdmin"
                    ref="has-done-kakao"
                    :csrf-token="csrfToken"
                ></app-qna-has-done-kakao>
            </h5>

            <div class="uk-width-expand">

            </div>

            <div v-if="!hasGeneralAdmin" class="uk-margin-small-right uk-text-danger">
                * 댓글을 작성하시고, 할당을 [창고] 또는 [한국총괄]로 지정해 주셔야 합니다.
            </div>
        </div>

        <div>
            <!-- 댓글작성 -->
            <div class="uk-margin-bottom uk-margin-top">
                <div class="uk-margin-left">
                    <!-- 작성자 -->
                    <div class="uk-margin-small-bottom">
                        <i class="material-icons uk-text-middle">
                            account_circle
                        </i>
                        <span class="uk-text-bold">{{ loginUserNick }}</span>
                    </div>
                    <app-input-ex
                            type="textarea"
                            name="comment"
                            v-model="comment"
                            :textarea-rows="4"
                            placeholder="댓글을 작성하세요"
                    ></app-input-ex>

                    <!-- 총괄관리자: 할당/알림톡 옵션 -->
                    <div v-if="hasGeneralAdmin" class="admin-save-bar uk-flex uk-flex-middle uk-flex-center uk-margin-small-top">
                        <!-- 할당변경 radio (QnA 전용) -->
                        <div v-if="qnaId !== null" class="admin-save-bar__group uk-flex uk-flex-middle">
                            <span class="uk-text-muted uk-margin-small-right">할당:</span>
                            <label class="uk-margin-small-right">
                                <input type="radio" class="uk-radio" v-model="allocateTo" value="1"> 한국총괄
                            </label>
                            <label>
                                <input type="radio" class="uk-radio" v-model="allocateTo" value="3"> 사용자
                            </label>
                        </div>

                        <!-- 알림톡 checkbox (QnA 전용) -->
                        <div v-if="qnaId !== null" class="admin-save-bar__group uk-flex uk-flex-middle">
                            <label>
                                <input type="checkbox" class="uk-checkbox" v-model="sendKakao">
                                <img src="/img/kakao/talk.png" class="w-20 uk-margin-small-left" style="vertical-align: middle;" />
                                알림톡발송
                            </label>
                        </div>

                        <!-- 저장 -->
                        <div class="admin-save-bar__group">
                            <button
                                    class="uk-button uk-button-primary"
                                    v-on:click="writeComment"
                                    :disabled="commentInputDisabled || submitting"
                            >
                                <span uk-icon="icon: check"></span> 저장
                            </button>
                        </div>
                    </div>

                    <!-- 일반: 저장 버튼만 -->
                    <button
                            v-else
                            class="uk-button uk-button-primary uk-width-1-1 uk-margin-small-top"
                            v-on:click="writeComment"
                            :disabled="commentInputDisabled"
                    >
                        <span uk-icon="icon: check"></span> 저장
                    </button>
                </div>
            </div>

            <!-- 활동내역 표시  -->
            <div
                    v-for="(activity, index) in visibleActivities"
                    :key="index"
                    class="uk-margin-top uk-margin-left"
            >
                <app-cm-activity
                        :activity="activity"
                        :comment-editable="loginUserNick === activity.created_by"
                        :csrf-token="csrfToken"
                ></app-cm-activity>
            </div>
        </div>

        

        <!-- 댓글등록 완료화면 -->
        <comment-writed ref="writed"></comment-writed>
    </div>
</template>

<script>
    export default {
        components: {
            'comment-writed': require('./comment-writed.vue').default,
        },
        props: {
            /**
             * 커뮤니케이션 ID
             */
            cmId: {
                type: Number,
                default: null
            },
            /**
             * 로그인 사용자 닉네임
             */
            loginUserNick: {
                type: String,
                default: null
            },
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },
            /**
             * 관리자권한있음 (총괄+지역 포함)
             */
            hasAdmin: {
                type: Boolean,
                default: false
            },
            /**
             * 총괄관리자 권한있음
             */
            hasGeneralAdmin: {
                type: Boolean,
                default: false
            },

            /**
             * 문의게시판인경우, qna_id
             */
            qnaId: {
                type: Number,
                default: null
            },
            /**
             * 할당 대상 사용자ID (총괄관리자+QnA 전용)
             */
            allocateUserId: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                /**
                 * 댓글작성 textarea
                 */
                comment: null,
                /**
                 * 활동내역 리스트
                 * [
                 *  {
                 *      id: 활동내역ID,
                 *
                 *      type: ,
                 *      p1: ,
                 *      p2: ,
                 *      comment: ,
                 *
                 *      updated_at: 수정일 텍스트,
                 *      created_at: 생성일 텍스트,
                 *      updated_by: 수정자 텍스트,
                 *      created_by: 생성자 텍스트,
                 *  },
                 *  {},
                 *  {}
                 * ]
                 */
                activities: [],
                /**
                 * 활동내역을 전부 표시할지 여부
                 * - false : 댓글만 표시
                 * - true : 전체 활동내역 표시
                 */
                showDetail: false,
                /**
                 * 할당변경 radio (QnA 전용)
                 */
                allocateTo: '3',
                /**
                 * 알림톡발송 checkbox (QnA 전용)
                 */
                sendKakao: true,
                /**
                 * 저장 처리중 여부
                 */
                submitting: false,
            };
        },
        computed: {
            /**
             * 화면에 보여지는 활동내역 리스트
             * - 설정에 따라 댓글만 필터링한 리스트가 반환됨
             * @return []
             */
            visibleActivities: function () {
                if (this.showDetail) {
                    // 전체내역
                    return this.activities;
                } else {
                    // 댓글만
                    return _.filter(this.activities, function (obj) {
                        return obj.type === 1;
                    });
                }

            },
            /**
             * 댓글 입력 textarea disabled
             * @return bool
             */
            commentInputDisabled: function () {
                if (! this.comment) {
                    return true;
                } else if (this.comment === '') {
                    return true;
                }
                return false;
            },
        },
        watch: {
        },
        mounted: function () {
            // 리스트 로드
            this.refreshList();

        },
        methods: {

            /**
             * 활동내역 ajax load
             */
            refreshList: function () {
                let cmp = this;
                let opts = {
                    type: 'get',
                    url: '/communications/'+this.cmId+'/activities',

                    success: function (res) {
                        //console.log(res);

                        cmp.activities = []; // 초기화

                        _.forEach(res.activities, function (obj) {
                            cmp.activities.push(obj);
                        });

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);


            },

            /**
             * ajax를 Promise로 래핑
             */
            ajaxPromise: function (opts) {
                return new Promise((resolve, reject) => {
                    opts.success = (response) => resolve(response);
                    opts.error = (xhr) => reject(xhr);
                    $.app.ajax.module.default(opts);
                });
            },

            /**
             * 댓글작성
             */
            writeComment: function () {
                if (this.hasGeneralAdmin) {
                    this.writeCommentAdmin();
                } else {
                    this.writeCommentDefault();
                }
            },

            /**
             * 댓글작성 (일반)
             */
            writeCommentDefault: function () {
                let opts = {
                    type: 'post',
                    url: '/communications/'+this.cmId+'/comments',
                    data: {
                        '_token': this.csrfToken,
                        'comment': this.comment
                    },
                    success: () => {
                        this.$refs.writed.show();
                    }
                };
                $.app.ajax.module.default(opts);
            },

            /**
             * 댓글작성 (총괄관리자)
             * A(댓글저장) → B(할당변경, QnA) → C(알림톡발송, QnA) 순차 처리
             */
            writeCommentAdmin: async function () {
                this.submitting = true;
                const results = [];

                try {
                    // A) 댓글 저장
                    await this.ajaxPromise({
                        type: 'post',
                        url: '/communications/' + this.cmId + '/comments',
                        data: {
                            '_token': this.csrfToken,
                            'comment': this.comment
                        }
                    });
                    results.push('댓글 저장 완료');

                    // B) 할당 변경 (QnA 전용)
                    if (this.qnaId !== null) {
                        const allocateLabel = this.allocateTo === '1' ? '한국총괄' : '사용자';
                        await this.ajaxPromise({
                            type: 'patch',
                            url: '/communications/' + this.cmId + '/allocate',
                            data: {
                                '_token': this.csrfToken,
                                'allocate_to': this.allocateTo,
                                'allocate_user_id': this.allocateUserId
                            }
                        });
                        results.push('할당 → ' + allocateLabel);
                    }

                    // C) 알림톡 발송 (QnA + 체크된 경우만)
                    if (this.qnaId !== null && this.sendKakao) {
                        await this.ajaxPromise({
                            type: 'post',
                            url: '/qnas/' + this.qnaId + '/has-done-kakao',
                            data: {
                                '_token': this.csrfToken
                            }
                        });
                        results.push('알림톡 발송 접수');
                    }

                    // 완료 알럿
                    UIkit.modal.alert(results.join('<br>')).then(() => {
                        $.app.refresh();
                    });

                } catch (e) {
                    this.submitting = false;
                    // 에러는 $.app.ajax.module.default 내부에서 처리됨
                }
            }

        }
    }
</script>

<style lang="scss" scoped>
    .component-header {
        border-bottom: 1px solid #999;
    }

    .admin-save-bar__group {
        padding: 0 15px;

        & + & {
            border-left: 1px solid #ddd;
        }
    }
</style>